import React from "react";
import './footer.scss';
import EnergicLogo from "../../../components/ui/EnergicLogo";
import {graphql, Link, useStaticQuery} from "gatsby";
import routes from "../../../services/routes";
import NewsletterForm from "../newsletterForm/NewsletterForm";
import SocialNetworks from "../socialNetworks/SocialNetworks";
import {GatsbyImage} from "gatsby-plugin-image";

const Footer = () => {

    const data = useStaticQuery(graphql`
    query FooterImagesQuery {
      gouv: file(name: {eq: "logo_fr"}) {
        id
        childImageSharp {
            gatsbyImageData(layout: CONSTRAINED)
        }
      }
      euraclimat: file(name: {eq: "logo_euraclimat"}) {
        id
        childImageSharp {
            gatsbyImageData(layout: CONSTRAINED)
        }
      }
    }
  `);

    return (
        <footer>
            <div className='footerContainer'>
                <EnergicLogo white />
                <div className='footerContent'>
                    <div className='footerSection'>
                        <h5>À propos</h5>
                        <Link to={routes.contact.root}>
                            Nous contacter
                        </Link>
                        <Link to={routes.team}>
                            Tout savoir sur Energic
                        </Link>
                        <Link to={routes.team + '#rejoindre'}>
                            Recrutement
                        </Link>
                        <Link to={routes.footer.websitePolicy}>
                            Politique de confidentialité (RGPD)
                        </Link>
                        <Link to={routes.footer.rgpd}>
                            Politique de confidentialité - Joueurs
                        </Link>
                        <Link to={routes.footer.recruitmentPolicy}>
                            Politique de confidentialité - Recrutement
                        </Link>
                        <Link to={routes.footer.termsOfUse}>
                            Conditions d'utilisation
                        </Link>
                        <Link to={routes.footer.disclaimer}>
                            Mentions légales
                        </Link>
                    </div>
                    <div className='footerSection'>
                        <h5>Nos services</h5>
                        <Link to={routes.challenge.internal}>
                            Challenge interne
                        </Link>
                        <Link to={routes.challenge.companies}>
                            Challenge inter-entreprises
                        </Link>
                        <Link to={routes.challenge.school}>
                            Challenge étudiants
                        </Link>
                        <Link to={routes.challenge.tenant}>
                            Challenge locataires
                        </Link>
                    </div>
                    <div className='footerSection'>
                        <h5>Les ressources</h5>
                        <Link to={routes.resources.footprint}>
                            Réaliser son bilan carbone
                        </Link>
                        <Link to={routes.blog}>
                            Nos actualités
                        </Link>
                        <h5>Soutenu par</h5>
                        <div className='gouvLogos'>
                            <GatsbyImage
                                alt="Illustration : Gouvernement français"
                                image={data?.gouv?.childImageSharp?.gatsbyImageData}
                                objectFit="contain"
                                className="GouvLogoImage"
                            />
                            <GatsbyImage
                                alt="Illustration : Euraclimat"
                                image={data?.euraclimat?.childImageSharp?.gatsbyImageData}
                                objectFit="contain"
                                className="EuraclimatLogoImage"
                            />
                        </div>
                    </div>
                    <div className='footerSection'>
                        <h5>Store</h5>
                        <div className='storeButtons'>
                            <a
                                href="https://play.google.com/store/apps/details?id=io.energic.app"
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Lien vers l'application Android Energic"
                                className={['playStoreButton', 'storeButton'].join(' ')}
                            />
                            <a
                                href="https://itunes.apple.com/fr/app/energic-new/id1455362671"
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Lien vers l'application iOS Energic"
                                className={['appStoreButton', 'storeButton'].join(' ')}
                            />
                        </div>
                        <h5>Newsletter</h5>
                        <NewsletterForm/>
                        <h5>Suivez-nous sur</h5>
                        <SocialNetworks/>
                    </div>
                </div>
                <hr/>
                <p className='copyright' id="newsletter">
                    © 2023 Energic - Tous droits réservés - Réalisé avec 💛 à Lille - Design par <a
                    href='https://antsandbees.fr/' target='_blank' title="Site web Ants&Bees"
                    className='antsCopyright'>Ants&Bees</a>
                </p>
            </div>
        </footer>
    );
};

export default Footer;